import type { APIMainPageCollection } from '@/types'

import battleRoyale from './icons/battle-royale.webp'
import bike from './icons/bike.webp'
import boxing from './icons/boxing.webp'
import building from './icons/building.webp'
import car from './icons/car.webp'
import clicker from './icons/clicker.webp'
import coOp from './icons/co-op.webp'
import cooking from './icons/cooking.webp'
import dinosaur from './icons/dinosaur.webp'
import driving from './icons/driving.webp'
import fighting from './icons/fighting.webp'
import fishing from './icons/fishing.webp'
import hiddenObject from './icons/hidden-object.webp'
import idle from './icons/idle.webp'
import io from './icons/io.webp'
import mahjong from './icons/mahjong.webp'
import merge from './icons/merge.webp'
import multiplayer from './icons/multiplayer.webp'
import puzzle from './icons/puzzle.webp'
import racing from './icons/racing.webp'
import secret from './icons/secret.webp'
import space from './icons/space.webp'
import survival from './icons/survival.webp'
import trendingNow from './icons/trending-now.webp'
import tycoon from './icons/tycoon.webp'
import war from './icons/war.webp'

const ICONS = new Map([
    ['battle-royale', battleRoyale],
    ['bike', bike],
    ['boxing', boxing],
    ['building', building],
    ['building-games', building],
    ['car', car],
    ['clicker', clicker],
    ['co-op', coOp],
    ['construction', building],
    ['cooking', cooking],
    ['dinosaur', dinosaur],
    ['driving', driving],
    ['fighting', fighting],
    ['fishing', fishing],
    ['hidden-object', hiddenObject],
    ['idle', idle],
    ['io', io],
    ['mahjong', mahjong],
    ['merge', merge],
    ['motorbike', bike],
    ['multiplayer', multiplayer],
    ['puzzle', puzzle],
    ['racing', racing],
    ['secret', secret],
    ['space', space],
    ['survival', survival],
    ['trending_now', trendingNow],
    ['tycoon', tycoon],
    ['war', war],
])

// the first collection is the hero card; the rest are tiles, and a tile without an icon is dropped
export function getCollectionTiles(collections: APIMainPageCollection[]) {
    return collections.slice(1).flatMap((collection) => {
        const source = collection.collection_source_category_hru
        const icon = source ? ICONS.get(source) : undefined
        return icon ? [{ ...collection, icon }] : []
    })
}
